import { lazy, Suspense } from "react";
import { useSelector } from "react-redux";

// Renderiza el componente solo si el user logueado es super_admin.
// Para cualquier otro role (o anónimo) → muestra NotFound (404 visual).
// Se usa para gatear rutas de templates demo del theme Flone que no son parte
// del flujo activo de Delplastic.
const NotFound = lazy(() => import("../pages/other/NotFound"));

const SuperAdminRoute = ({ children }) => {
  const role = useSelector((state) => state.auth.user?.role);

  if (role !== "super_admin") {
    return (
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
    );
  }

  return children;
};

export default SuperAdminRoute;
